import type { PaginatedResponse, RatedAgeType } from "types/DataTypes";

import { api } from "./api";

export const ratedAgeAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getRatedAges: build.query<
      RatedAgeType[],
      { msaId?: number; costProjectionId?: number }
    >({
      query: ({ msaId, costProjectionId }) => {
        const params = new URLSearchParams();
        if (msaId) params.append("msa", msaId.toString());
        if (costProjectionId)
          params.append("cost_projection", costProjectionId.toString());

        return {
          url: `api/v1/rated-ages/?${params.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response: PaginatedResponse<RatedAgeType>) => {
        return response.results || [];
      },
      providesTags: ["RatedAge"],
    }),
    createRatedAge: build.mutation<
      RatedAgeType,
      { data: Partial<RatedAgeType> }
    >({
      query: ({ data }) => ({
        url: `api/v1/rated-ages/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "RatedAge",
        "MSA",
        "MCP",
        "LCP",
        "MSAValidation",
        "CostProjectionValidation",
      ],
    }),
    updateRatedAge: build.mutation<
      RatedAgeType,
      { id: number; data: Partial<RatedAgeType> }
    >({
      query: ({ id, data }) => ({
        url: `api/v1/rated-ages/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "RatedAge",
        "MSA",
        "MCP",
        "LCP",
        "MSAValidation",
        "CostProjectionValidation",
      ],
    }),
    deleteRatedAge: build.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `api/v1/rated-ages/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [
        "RatedAge",
        "MSA",
        "MCP",
        "LCP",
        "MSAValidation",
        "CostProjectionValidation",
      ],
    }),
  }),
});

export const {
  useGetRatedAgesQuery,
  useCreateRatedAgeMutation,
  useUpdateRatedAgeMutation,
  useDeleteRatedAgeMutation,
} = ratedAgeAPI;
